(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  const nwFooterDashRoots = new Map();
  let nwFooterDashFrame = 0;

  function nwScheduleFooterDashes() {
    if (nwFooterDashFrame) return;
    nwFooterDashFrame = requestAnimationFrame(() => {
      nwFooterDashFrame = 0;
      const ratio = (window.devicePixelRatio || 1) * (window.visualViewport?.scale || 1);
      nwFooterDashRoots.forEach((entry, root) => {
        if (!root.isConnected) {
          entry.observer.disconnect();
          nwFooterDashRoots.delete(root);
          return;
        }
        const bounds = root.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
        const styles = getComputedStyle(root);
        const sizes = [
          ['--nwf-dash-thickness', '--nwf-dash-render-thickness', 1],
          ['--nwf-dash-width', '--nwf-dash-render-width', 10],
          ['--nwf-dash-hover-width', '--nwf-dash-render-hover-width', 26]
        ];
        sizes.forEach(([source, target, fallback]) => {
          const value = parseFloat(styles.getPropertyValue(source)) || fallback;
          const snapped = Math.max(1, Math.round(value * ratio)) / ratio + 'px';
          if (root.style.getPropertyValue(target) !== snapped) root.style.setProperty(target, snapped);
        });
        const positions = entry.dashes.map(item => {
          const rect = item.element.getBoundingClientRect();
          const left = rect.left - item.x;
          const top = rect.top - item.y;
          return { item, x: Math.round(left * ratio) / ratio - left, y: Math.round(top * ratio) / ratio - top };
        });
        positions.forEach(({ item, x, y }) => {
          if (Math.abs(item.x - x) > .001 || Math.abs(item.y - y) > .001) {
            item.element.style.setProperty('--nwf-dash-snap-x', x + 'px');
            item.element.style.setProperty('--nwf-dash-snap-y', y + 'px');
            item.x = x;
            item.y = y;
          }
        });
      });
    });
  }

  function nwBindFooterDashes() {
    document.querySelectorAll('.nw-footer').forEach(root => {
      if (nwFooterDashRoots.has(root)) return;
      const dashes = Array.from(root.querySelectorAll('.nw-footer__column-link-dash'), element => ({ element, x: 0, y: 0 }));
      if (!dashes.length) return;
      const observer = new ResizeObserver(nwScheduleFooterDashes);
      observer.observe(root);
      nwFooterDashRoots.set(root, { dashes, observer });
    });
    nwScheduleFooterDashes();
  }

  nwBindFooterDashes();
  window.addEventListener('scroll', nwScheduleFooterDashes, { passive: true });
  window.addEventListener('resize', nwScheduleFooterDashes, { passive: true });
  window.addEventListener('load', nwScheduleFooterDashes);
  window.visualViewport?.addEventListener('resize', nwScheduleFooterDashes, { passive: true });
  document.fonts?.ready.then(nwScheduleFooterDashes);
  document.addEventListener('shopify:section:load', nwBindFooterDashes);
  document.addEventListener('shopify:section:unload', event => {
    nwFooterDashRoots.forEach((entry, root) => {
      if (event.target.contains(root)) {
        entry.observer.disconnect();
        nwFooterDashRoots.delete(root);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["performance-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(section) {
    if (section.dataset.carouselReady) return;
    const cards = [...section.querySelectorAll('.nw-card')];
    const texts = [...section.querySelectorAll('.nw-slide-text')];
    const stage = section.querySelector('.nw-card-stage');
    if (!stage || !cards.length) return;
    section.dataset.carouselReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    let active = 0, gesture = null, suppressUntil = 0, wheelTotal = 0, wheelAt = 0, wheelLock = 0;
    const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal});
    function show(index) {
      active = (index + cards.length) % cards.length;
      cards.forEach((card, i) => {
        card.classList.remove('active', 'left', 'right', 'hidden');
        const state = i === active ? 'active' : i === (active + 1) % cards.length ? 'right' : i === (active - 1 + cards.length) % cards.length ? 'left' : 'hidden';
        card.classList.add(state);
        card.inert = state === 'hidden';
      });
      texts.forEach((text, i) => {
        text.classList.toggle('active', i === active);
        text.inert = i !== active;
      });
      section.querySelectorAll('.nw-card-dot').forEach(dot => {
        const selected = Number(dot.dataset.dot) === active;
        dot.classList.toggle('active', selected);
        dot.setAttribute('aria-pressed', String(selected));
        dot.tabIndex = dot.closest('.nw-card').classList.contains('active') ? 0 : -1;
      });
      section.querySelectorAll('.nw-arrow').forEach(button => button.disabled = cards.length < 2);
    }
    on(stage, 'click', event => {
      if (Date.now() < suppressUntil) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      const dot = event.target.closest('[data-dot]');
      if (dot) { show(Number(dot.dataset.dot)); return; }
      if (event.target.closest('.nw-next')) { show(active + 1); return; }
      if (event.target.closest('.nw-prev')) { show(active - 1); return; }
      const card = event.target.closest('[data-card]');
      if (card) show(Number(card.dataset.card));
    });
    on(stage, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      show(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
      stage.focus({preventScroll:true});
    });
    let touchGesture = null;
    on(stage, 'touchstart', event => {
      if (event.touches.length !== 1 || cards.length < 2) { touchGesture = null; return; }
      const touch = event.touches[0];
      touchGesture = {id:touch.identifier,x:touch.clientX,y:touch.clientY};
    }, {passive:true});
    on(stage, 'touchmove', event => {
      if (!touchGesture) return;
      if (event.touches.length !== 1) { touchGesture = null; return; }
      const touch = event.touches[0];
      const dx = touch.clientX - touchGesture.x, dy = touch.clientY - touchGesture.y;
      if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { touchGesture = null; return; }
      if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) && event.cancelable) event.preventDefault();
    }, {passive:false});
    on(stage, 'touchend', event => {
      if (!touchGesture) return;
      const start = touchGesture;
      touchGesture = null;
      const touch = [...event.changedTouches].find(item => item.identifier === start.id);
      if (!touch) return;
      const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
      if (Math.abs(dx) > 12) suppressUntil = Date.now() + 450;
      if (Math.abs(dx) >= 30 && Math.abs(dx) > Math.abs(dy) * 1.3) show(active + (dx < 0 ? 1 : -1));
    }, {passive:true});
    on(stage, 'touchcancel', () => { touchGesture = null; }, {passive:true});
    on(stage, 'dragstart', event => event.preventDefault());
    on(stage, 'pointerdown', event => {
      if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0 || cards.length < 2 || event.target.closest('button,a')) return;
      gesture = {id:event.pointerId,x:event.clientX,y:event.clientY};
    });
    on(stage, 'pointermove', event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { gesture = null; return; }
      if (Math.abs(dx) > 12) {
        stage.setPointerCapture(event.pointerId);
        stage.classList.add('is-dragging');
      }
    });
    function finish(event) {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      gesture = null;
      stage.classList.remove('is-dragging');
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      if (Math.abs(dx) > 12) suppressUntil = Date.now() + 450;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3) show(active + (dx < 0 ? 1 : -1));
    }
    on(stage, 'pointerup', finish);
    on(stage, 'pointercancel', () => { gesture = null; stage.classList.remove('is-dragging'); });
    on(stage, 'lostpointercapture', () => { gesture = null; stage.classList.remove('is-dragging'); });
    on(stage, 'wheel', event => {
      if (event.ctrlKey || cards.length < 2) return;
      const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      if (!horizontal && !event.shiftKey) return;
      event.preventDefault();
      const now = Date.now();
      if (now < wheelLock) return;
      let delta = horizontal ? event.deltaX : event.deltaY;
      delta *= event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? stage.clientWidth : 1;
      if (now - wheelAt > 180 || Math.sign(delta) !== Math.sign(wheelTotal)) wheelTotal = 0;
      wheelAt = now;
      wheelTotal += delta;
      if (Math.abs(wheelTotal) >= 45) { show(active + Math.sign(wheelTotal)); wheelTotal = 0; wheelLock = now + 550; }
    }, {passive:false});
    on(document, 'shopify:block:select', event => {
      const card = event.target.closest('[data-card]');
      if (card && section.contains(card)) show(Number(card.dataset.card));
    });
    on(document, 'shopify:section:unload', event => {
      if (event.target.contains(section)) { controller.abort(); delete section.dataset.carouselReady; }
    });
    show(0);
  }
  const initAll = root => root.querySelectorAll('.nw-carousel-section').forEach(init);
  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["setup-spotlight"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const frames = new Map();
    instances.set(root, () => {
      controller.abort();
      frames.forEach(cancelAnimationFrame);
      frames.clear();
      instances.delete(root);
    });
    root.querySelectorAll('[data-hover-speed]').forEach(row => {
      const track = row.querySelector('.nw-spotlight__track');
      if (!track || !track.getAnimations) return;
      function changeSpeed(target) {
        const animation = track.getAnimations().find(item =>
          item.animationName === 'nwSpotlightScrollLeft' || item.animationName === 'nwSpotlightScrollRight'
        );
        if (!animation || !animation.updatePlaybackRate) return;
        cancelAnimationFrame(frames.get(row));
        const startRate = animation.playbackRate;
        const started = performance.now();
        function tick(now) {
          if (!root.isConnected) { frames.delete(row); return; }
          const progress = Math.min(1, (now - started) / 300);
          const eased = progress * progress * (3 - 2 * progress);
          animation.updatePlaybackRate(startRate + (target - startRate) * eased);
          if (progress < 1) frames.set(row, requestAnimationFrame(tick));
          else frames.delete(row);
        }
        frames.set(row, requestAnimationFrame(tick));
      }
      row.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        changeSpeed(Math.max(0.1, Math.min(1, Number(row.dataset.hoverSpeed) / 100 || 0.25)));
      }, { signal: controller.signal });
      row.addEventListener('pointerleave', () => changeSpeed(1), { signal: controller.signal });
      row.addEventListener('pointercancel', () => changeSpeed(1), { signal: controller.signal });
    });
  }
  function initWithin(scope) { scope.querySelectorAll('.nw-spotlight').forEach(init); }
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.nw-spotlight').forEach(root => instances.get(root)?.());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
